import ProductCategoryNorms from './ProductCategoryNorms';
export default ProductCategoryNorms;
